import { isBrowser } from "src/utilities/env"

export function recordError(message: string, cause?: unknown) {
  let combinedMessage = message
  let lastError = cause

  while (lastError) {
    if (typeof lastError === "string") {
      combinedMessage += `: [string] ${lastError}`
      lastError = undefined
    } else if (lastError instanceof Error) {
      combinedMessage += `: [Error] ${lastError.stack || lastError.message || String(lastError)}`
      lastError = lastError.cause
    } else {
      combinedMessage += `: [any] ${JSON.stringify(lastError, null, 2) || String(lastError)}`
      lastError = undefined
    }
  }

  console.error(combinedMessage, { cause })

  if (isBrowser) {
    import("src/integrations/posthog/client-web").then(({ withPosthogWeb }) => {
      withPosthogWeb((posthog) => {
        posthog.captureException(new Error(combinedMessage))
      })
    })
  }
}
